import { EApiLanguageCode } from '@datatype/iyagigo/api-type';
/** @jsxImportSource @emotion/react */

import React from 'react';
import { useLocation } from 'react-router-dom';
import { useTypedDispatch, useTypedSelector } from '@hook/common/useStore';
import Problem from '@component/iyagigo/test/problem';
import { IIyagigoMenu } from '@datatype/iyagigo/type';
import { INVALID_URL } from '@constant/error';
import PageTemplate from '@page/iyagigo/page-template';
import { actions as modalActions } from '@store/slice/modal-slice';
import * as size from '@constant/size';
import { getTestCodeFromCurrentStudy, getIsTodayStudied } from '@util/workbook';
import { useTodayTestWorkbookQuery } from '@hook/iyagigo/useApi';
import HeaderProgress from '@component/iyagigo/common/header-progress';

const ProblemPage: React.FC<any> = () => {
  // ############### route ###############
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const languagePath = searchParams.get('language');
  const subjectPath = searchParams.get('subject');
  if (!languagePath && !subjectPath) throw new Error(INVALID_URL);

  // ############### api ###############
  const isAuthenticated = useTypedSelector((state) => state.rootReducer.userReducer.isAuthenticated) ?? false;
  const currentStudyLanguage =
    useTypedSelector((state) => state.rootReducer.studentReducer.currentStudyLanguage) ?? null;
  const currentToeicTest = useTypedSelector((state) => state.rootReducer.studentReducer.currentToeicTest) ?? null;
  const currentJlptTest = useTypedSelector((state) => state.rootReducer.studentReducer.currentJlptTest) ?? null;
  const currentTest = currentStudyLanguage === EApiLanguageCode.ENGLISH ? currentToeicTest : currentJlptTest;

  const testCode = getTestCodeFromCurrentStudy(currentTest);
  const query = useTodayTestWorkbookQuery(testCode);
  const data = query.data?.data || [];
  const totalCount = data.length || 0;

  const notStudiedWorkbook = data.filter((item) => !getIsTodayStudied(item.todayStudiedAt ?? '')) || [];
  const initialWorkbookIdx = data.length - notStudiedWorkbook.length;

  // ############### state ###############
  const workbookIdx = useTypedSelector((state) => state.rootReducer?.workbookReducer?.testWorkbookIdx) || 0;
  const testMenu = (useTypedSelector((state) => state.rootReducer?.navigationReducer?.iyagigo?.subMenu) ??
    null) as IIyagigoMenu['test'];
  const dispatch = useTypedDispatch();

  // ############### variable ###############
  const HEADER_TITLE = currentStudyLanguage === EApiLanguageCode.ENGLISH ? '영어 시험' : '일본어 시험';

  return (
    <PageTemplate
      title={HEADER_TITLE}
      mode={'back'}
      handleNavigationClick={() =>
        dispatch(modalActions.showDialogModal({ type: 'workbook-quit', data: { mainMenu: 'test' } }))
      }
      customHeader={
        <HeaderProgress currentProgress={initialWorkbookIdx} totalProgress={totalCount} />
      }>
      <Problem test={testMenu} />
    </PageTemplate>
  );
};

export default ProblemPage;
